module.exports = __webpack_public_path__ + "rt_ico.png?b1301e3a4d227b1453a1fbf7f2f70d0f";